import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {
    generateBonusIndicator,
    generateEarlyPayoutIndicator,
} from '#core/application/modules/tiles/bonus-indicator/index.js';
import {generateBetBuilderSelectionItem} from '#core/application/modules/tiles/bet-builder-selection-item/index.js';
import {BET_FUNDS_INFO_TYPES, generateBetFundsInfo} from '#core/application/modules/tiles/bet-funds-info/index.js';
import {generateChangedValueIndicator} from '#core/application/modules/tiles/changed-value-indicator/index.js';
import {generateInfoNotification} from '#core/application/modules/tiles/notification/index.js';

import BET_BASE_INFO from './bet-base-info.palette-schema.yaml';

registerTileSchema(BET_BASE_INFO);

export function generateBetBaseInfo(TILE) {
    return {
        title: {
            ...TILE.BET_TITLE_TEXT,
        },
        date: {
            ...TILE.BET_DATE_TEXT,
        },
        scanDate: {
            ...TILE.BET_SCAN_DATE_TEXT,
        },
        suspendedNotification: {
            borderRadius: 4,
            padding: 4,
            ...resolveBackground(TILE.BET_SUSPENDED_NOTIFICATION.WARNING_BG),
            alignSelf: 'baseline',
            ...TILE.BET_SUSPENDED_NOTIFICATION_WARNING_TEXT,
        },
        betStatus: {
            ...TILE.BET_STATUS_TEXT,
        },
        selectionName: {
            overflowWrap: 'anywhere',
            ...TILE.BET_SELECTION_NAME_TEXT,
        },
        betType: {
            ...TILE.BET_TYPE_TEXT,
        },
        betTotalOdds: {
            label: {
                style: {
                    ...TILE.BET_TOTAL_ODDS_LABEL_TEXT,
                },
            },
            value: {
                style: {
                    ...TILE.BET_TOTAL_ODDS_VALUE_TEXT,
                },
            },
            priceBoostIndicator: generateChangedValueIndicator(TILE.BET_TOTAL_ODDS_PRICE_BOOST_CVI, {
                SHOW_ICON: true,
                HIGHLIGHT_NEW_VALUE: false,
            }),
        },
        odds: {
            ...TILE.BET_ODDS_TEXT,
        },
        oddsChangedValue: generateChangedValueIndicator(TILE.BET_ODDS_CVI),
        priceBoostValue: generateChangedValueIndicator(TILE.BET_PRICE_BOOST_CVI, {
            SHOW_ICON: true,
            HIGHLIGHT_NEW_VALUE: false,
        }),
        startingPriceIndicator: generateChangedValueIndicator(TILE.BET_STARTING_PRICE_CVI, {
            SHOW_ICON: false,
            HIGHLIGHT_NEW_VALUE: false,
        }),
        marketName: {
            overflowWrap: 'anywhere',
            ...TILE.BET_MARKET_NAME_TEXT,
        },
        eventName: {
            overflowWrap: 'anywhere',
            ...TILE.BET_EVENT_NAME_TEXT,
        },
        multiplesInfo: {
            ...TILE.BET_MULTIPLES_INFO_TEXT,
        },
        betBuilderSelectionName: {
            ...TILE.BET_BUILDER_BET_SELECTION_NAME_TEXT,
        },
        betBuilderMarketName: {
            ...TILE.BET_BUILDER_BET_MARKET_NAME_TEXT,
        },
        betBuilderSelectionItem: generateBetBuilderSelectionItem(TILE.BET_BUILDER_SELECTION_ITEM),
        betFundsInfo: {
            normal: generateBetFundsInfo(TILE.BET_FUNDS_INFO, BET_FUNDS_INFO_TYPES.NORMAL),
            medium: generateBetFundsInfo(TILE.BET_FUNDS_INFO, BET_FUNDS_INFO_TYPES.MEDIUM),
            emphasized: generateBetFundsInfo(TILE.BET_FUNDS_INFO, BET_FUNDS_INFO_TYPES.EMPHASIZED),
        },
        betBonusIndicator: generateBonusIndicator(TILE.BET_BONUS_INDICATOR),
        earlyPayoutIndicator: generateEarlyPayoutIndicator(TILE.EARLY_PAYOUT_INDICATOR),
        bestOddsIcon: icon(TILE.BET_BEST_ODDS_GUARANTEED_ICON_COLOR, 'racing-bestodds'),
        voidReasonNotification: {
            container: {
                style: {
                    padding: '4px 0 0',
                },
            },
            notification: generateInfoNotification(TILE.BET_VOID_REASON_NOTIFICATION),
        },
    };
}
